import { useState, useCallback, useRef, useEffect } from 'react'

interface useCountdownReturn {
  count: number
  start: (startValue?: number) => void
  stop: () => void
  isActive: boolean
}

const useCountdown = (initialValue = 0): useCountdownReturn => {
  const [count, setCount] = useState<number>(initialValue)
  const intervalRef = useRef<NodeJS.Timeout | null>(null)

  const start = useCallback((startValue = 5): void => {
    setCount(startValue)

    if (intervalRef.current) {
      clearInterval(intervalRef.current)
    }

    if (startValue > 0) {
      intervalRef.current = setInterval(() => {
        setCount((current) => {
          const timeLeft = current - 1 || 0

          if (!timeLeft) {
            if (intervalRef.current) {
              clearInterval(intervalRef.current)
            }

            intervalRef.current = null
          }

          return timeLeft
        })
      }, 1000)
    }
  }, [])

  const stop = useCallback((): void => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current)
      intervalRef.current = null
    }

    setCount(0)
  }, [])

  useEffect(() => {
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
      }
    }
  }, [])

  return { count, start, stop, isActive: count > 0 }
}

export default useCountdown
